module.exports = __webpack_public_path__ + "img/三人男篮.aefeed25.png";